export default __webpack_public_path__ + "static/media/ac_rcl.ce6b4219.bmp";